var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-banner",style:({ backgroundImage: `url(${_vm.backgroundImg}), radial-gradient(48% 142%, #000B33 44%, #000B33 100%)` })},[_c('div',{staticClass:"banner-content"},[_c('div',{staticClass:"banner-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"banner-subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }